import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpParams} from "@angular/common/http";
import {EMPTY, Observable, of, Subject} from "rxjs";
import {AuditLessonDataModel} from "../models/auditLessonData.model";
import {catchError, retry, shareReplay} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class LessonDataService {

  private readonly auditResultsProperty = 'auditLessonName';
  private LESSON_DATA_API_URL = environment.LESSON_DATA_SVC_URL;

  private lessonDataItems: AuditLessonDataModel[];
  private lessonDataItemsSubject: Subject<any[]>;
  lessonDataItemsObservable: Observable<any[]>;

  constructor(private httpClient: HttpClient) {
    this.lessonDataItemsSubject = new Subject<any[]>();
    this.lessonDataItemsObservable = this.lessonDataItemsSubject.asObservable();
  }

  getLessonData(lessonNodeIds: number[]): AuditLessonDataModel[] {
    this.sendGetRequest(lessonNodeIds).subscribe((
        (data: any[]) => {
          this.lessonDataItems = data[this.auditResultsProperty];
          this.lessonDataItemsSubject.next(this.lessonDataItems);
        }
    ));
    return this.lessonDataItems;
  }

  public sendGetRequest(lessonNodeIds: number[]) {
    const URL = this.LESSON_DATA_API_URL + '?nodeIds=' + lessonNodeIds;
    return this.httpClient.get(URL).pipe(
        retry(3),
        catchError(() => {
          return EMPTY;
        }),
        shareReplay()
    );
  }

  getLessonDataFoo(): AuditLessonDataModel[] {
    return this.lessonDataItems;
  }

}
